import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import shortid from 'shortid';
import { produce } from 'immer';

export default function useBuilder(props) {
  const { thisSurvey, handleChange } = props;
  const campaigns = useSelector(store => store.campaign.list || []);
  let [actionModels, setActionModels] = useState(
    thisSurvey.surveyQuestionResponseRules || []
  );
  let [updated, setUpdated] = useState(false);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (
      !updated &&
      thisSurvey &&
      thisSurvey.surveyQuestionResponseRules &&
      thisSurvey.surveyQuestionResponseRules.length > 0
    ) {
      setUpdated(true);
      setActionModels(thisSurvey.surveyQuestionResponseRules);
    }
  }, [thisSurvey.surveyQuestionResponseRules]);

  useEffect(() => {
    handleChange({
      target: {
        name: 'surveyQuestionResponseRules',
        value: actionModels.length > 0 ? actionModels : undefined
      }
    });
  }, [actionModels]);

  const actionParamModel = {
    campaignUuid: '',
    surveyQuestionName: '',
    matrixSubQuestionName: '',
    type: '',
    conditionData: {
      condition: '',
      conditionValue: ''
    },
    choices: [],
    subQuestionOptions: [],
    isMatrix: false
  };

  const addActionModel = () => {
    setActionModels(actionModels => {
      const newActionModels = [...actionModels];
      newActionModels.push({
        ...actionParamModel,
        id: shortid.generate()
      });
      return newActionModels;
    });
  };

  const getCampaign = (uuid) => {
    return campaigns.filter(campaign => campaign.uuid == uuid);
  };

  const updateActionModel = (id, event) => {
    let value = event.target.value;

    const newActionModels = produce(actionModels, draftActionModels => {
      switch (event.target?.name) {
        case 'surveyQuestionName':
          draftActionModels[id]['conditionData'].condition = '';
          draftActionModels[id]['conditionData'].conditionValue = '';
          draftActionModels[id].matrixSubQuestionName = '';
          draftActionModels[id].campaignUuid = '';
          draftActionModels[id].surveyQuestionName = value;
          const selectedQuestion = thisSurvey?.questions?.find(q => q.name === value);
          draftActionModels[id].type = selectedQuestion?.type;
          if(selectedQuestion?.type === "matrix") {
            draftActionModels[id].choices = [];
            draftActionModels[id].subQuestionOptions = selectedQuestion?.rows || [];
            draftActionModels[id].isMatrix = true;
          } else {
            draftActionModels[id].choices = selectedQuestion?.choices || [];
            draftActionModels[id].subQuestionOptions = [];
            draftActionModels[id].isMatrix = false;
          }
          break;
        case 'matrixSubQuestionName':
          draftActionModels[id]['conditionData'].condition = '';
          draftActionModels[id]['conditionData'].conditionValue = '';
          draftActionModels[id].matrixSubQuestionName = value;
          draftActionModels[id].choices =
            thisSurvey?.questions?.find(q => q.name === draftActionModels[id].surveyQuestionName)?.columns || [];
          break;
        case 'campaignUuid':
          draftActionModels[id][event.target?.name] = value;
          draftActionModels[id]['external'] = (getCampaign(value).length === 1) && (getCampaign(value))[0]?.campaignOccurrenceType === "EXTERNAL_SURVEY_RESPONSE";
          break;
        case 'conditionValue':
          if (!draftActionModels[id]?.choices?.length > 0) {
            draftActionModels[id]['conditionData'][event.target?.name] = value;
            draftActionModels[id]['conditionData'][
              'conditionValueText'
            ] = value;
          } else {
            draftActionModels[id].choices.map(option => {
              if (option?.value === value || option === value) {
                draftActionModels[id]['conditionData'][
                  event.target?.name
                ] = value;
                draftActionModels[id]['conditionData']['conditionValueText'] =
                  option?.text || option;
              }
            });
          }
          break;
        default:
          draftActionModels[id]['conditionData'][event.target?.name] = value;
          break;
      }
    });
    setActionModels(newActionModels);
  };

  const deleteActionModel = id => {
    setActionModels(actionModels => {
      const newActionModels = [...actionModels];
      if (newActionModels.length > 0) {
        newActionModels.splice(id, 1);
      }
      return newActionModels;
    });
  };

  return {
    actionModels,
    addActionModel,
    updateActionModel,
    deleteActionModel
  };
}
